export default __webpack_public_path__ + "static/media/herbalife3.6f13f729.mp4";